import { showControlTypeName } from '@/utils/control_type'
import { Col, Row } from 'antd'
import './../Checkpoints.style.less'

type Props = {
  data: any
  editComponent?: any
}

function ControlTypeMultiSelect({ data, editComponent = null }: Props) {
  const renderEditCheckpoint = editComponent ? (
    <Col span={1}>{editComponent()}</Col>
  ) : (
    <></>
  )
  return (
    <Col span={24}>
      <div className="control-type-multi-select-container page-break-inside">
        <Col span={12}>
          <p className="label">{showControlTypeName(data)}</p>
        </Col>
        <Col span={11}>
          <Row>
            {data?.value &&
              data?.value?.map((value, index) => {
                return (
                  <p className="value" key={index}>
                    {value.label}
                    {index === data?.value?.length - 1 ? '' : ','}
                  </p>
                )
              })}
          </Row>
        </Col>
        {renderEditCheckpoint}
      </div>
    </Col>
  )
}

export default ControlTypeMultiSelect
